export const OPTION_TEXT_COLORS = {
  gray: 'text-gray-400',
  red: 'text-red-400',
  yellow: 'text-yellow-500',
  green: 'text-green-400',
  blue: 'text-blue-400',
  indigo: 'text-indigo-400',
  purple: 'text-purple-400',
  pink: 'text-pink-400',
};
